import React from 'react';
import { Box } from '@mui/material';
import { leadInquiryTagSx } from './leadsUi.styles';

/**
 * Chips de origen de una consulta manual («Manual» + canal). Sin tags → nada.
 * Las tags salen de `getManualInquiryTags` (leadsConfig).
 *
 * @param {{ tags: string[], sx?: object }} props
 */
export default function InquiryOriginTags({ tags, sx = null }) {
  if (!Array.isArray(tags) || !tags.length) return null;
  return (
    <Box
      component="span"
      data-testid="inquiry-origin-tags"
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, flexShrink: 0, ...(sx || {}) }}
    >
      {tags.map((tag) => (
        <Box key={tag} component="span" sx={leadInquiryTagSx}>{tag}</Box>
      ))}
    </Box>
  );
}
